import*as e from"react";var t=function(e){return e.reduce((function(e,t){var n=t[0],o=t[1];return e[n]=o,e}),{})},n="undefined"!=typeof window&&window.document&&window.document.createElement?e.useLayoutEffect:e.useEffect;export{t as fromEntries,n as useIsomorphicLayoutEffect};
//# sourceMappingURL=utils.js.map
